import { MdOutlineClose } from "react-icons/md";
import { Suspense, FC } from "react";
import dynamic from "next/dynamic";
import Link from "next/link";
import useStore, { StoreState } from "../../context/useStore";

const Modal = dynamic(() => import("./../Modal"), {
  suspense: true,
});

const Steps = dynamic(() => import("./Steps"), {
  suspense: true,
});

interface AuthProps {
  open: boolean;
}

const Auth: FC<AuthProps> = ({ open }) => {
  const navbar = useStore((state) => state.dialog);
  const setDialog = useStore((state: StoreState) => state.setDialog);

  return (
    <>
      <Suspense
        fallback={
          <>
            <p>Loading...</p>
          </>
        }
      >
        <Modal
          onClose={() => {
            if (navbar.closable) {
              setDialog({
                open: false,
                closable: true,
              });
            }
          }}
          style={{ maxWidth: 400 }}
          visible={open}
        >
          <div className="p-5 relative">
            {navbar.closable && (
              <div className="absolute right-0 top-0">
                <button
                  onClick={() => {
                    setDialog({
                      open: false,
                      closable: true,
                    });
                  }}
                >
                  <MdOutlineClose />
                </button>
              </div>
            )}
            <Steps />
            <div className="mt-5 container mx-auto">
              <p className="text-center text-xs">
                By creating an account you acknowledge that you have read and
                agree to the{" "}
                <span>
                  <Link href="/terms">
                    <a className="text-blue-600">Privacy Policy</a>
                  </Link>
                </span>{" "}
                .
              </p>
            </div>
          </div>
        </Modal>
      </Suspense>
    </>
  );
};

export default Auth;
